// src/components/BottomNav.js
import { useNavigate } from 'react-router-dom';

const NAV = [
  { key: 'home',    icon: '⊞',  label: 'Home',     path: '/' },
  { key: 'search',  icon: '⌕',  label: 'Search',   path: '/search' },
  { key: 'offers',  icon: '⏱',  label: 'Offers',   path: '/offers' },
  { key: 'profile', icon: '👤', label: 'Profile',  path: '/profile' },
];

export default function BottomNav({ active }) {
  const navigate = useNavigate();
  return (
    <nav className="bottom-nav">
      {NAV.map(item => (
        <button
          key={item.key}
          className={`bottom-nav-item ${active === item.key ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span className="bottom-nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
